import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { useHistory, useLocation } from 'react-router-dom';

import Toast from '../../../components/Toast/Toast';
import { logging, logPostInfo } from '../../../actions/log';
import { CONTEXT } from '../../../config';
import styles from './SoftTag.module.less';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default props => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { forumData = {}, length, logInfo } = props;
  const logInfoData = useSelector(selectLogInfo);

  const handleTagSoft = useCallback(soft => {
    if (soft.softId) {
      dispatch(
        logging({
          category: 'C',
          action: 'Forum_Tag_Soft',
          label: '',
          param2: {
            source: logInfo.source,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            softId: soft.softId,
            softName: soft.name,
            id: forumData.id,
          },
        }),
      );
      dispatch(
        logPostInfo({
          source_p: `${logInfo.source}`,
          source_pp: logInfoData.source_p,
        }),
      );
      history.push(`${CONTEXT}/detail/soft/${soft.softId}/${soft.bizInfo || '{}'}`);
    } else {
      Toast.error({ content: '该软件尚未上架…' });
    }
  }, []);

  return (
    <div className={styles.forum_tags}>
      {forumData.passInfos &&
        forumData.passInfos.length > 0 &&
        forumData.passInfos.slice(0, length).map((item, i) => {
          return item.softId ? (
            <div
              className={styles.forum_tag_link}
              onClick={() => {
                handleTagSoft(item);
              }}
              key={i}
              title={item.name.length > 3 ? item.name : ''}
            >
              {item.name}
            </div>
          ) : (
            <div
              className={styles.forum_tag}
              onClick={() => {
                handleTagSoft(item);
              }}
              key={i}
              title={item.name.length > 3 ? item.name : ''}
            >
              {item.name}
            </div>
          );
        })}
    </div>
  );
};
